<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div style="text-align: center">
            <div class="d-flex flex-column k-gap-3">
              <state-filter v-model="filter.state_id" type="wallet_report" />
              <div class="d-flex w-50 flex-column k-gap-3 flex-md-row">
               <bita-bootbutton type="primary" title="خروجی اکسل" icon="fas fa-file-excel"
                @click.native="toggleExportForm"/>
                <bita-filtersbutton
                  icon="fas fa-filter"
                  :title="filterTitle"
                  @click="toggleFilters"
                />
                
                <bita-filtersbutton icon="fas fa-print" @click="print" />
              </div>
            </div>
            <tools :excel="urlExcel" />

            <transition name="fade">
              <div v-show="showFilters">
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-datepicker
                        type="date"
                        id="date"
                        validation-container-class="col-lg-2"
                        name="expire_at"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filter.from"
                      />
                      <bita-datepicker
                        type="date"
                        id="date"
                        validation-container-class="col-lg-2"
                        name="expire_at"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filter.to"
                      />
                      <bita-input
                        type="text"
                        name="search"
                        label="سرچ"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filter.search"
                        subtitle="سرچ بر اساس کدملی و شماره موبایل"
                      />
   
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <br />
          <!-- <transition name="fade">
            <div v-show="showFilters">
              <bita-form ref="form">
                <div slot="body">
                  <div class="row">
                    <bita-select
                      ref="statesDropDown"
                      name="states"
                      label="وضعیت"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="states"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.state_id"
                    />
                    <bita-datepicker
                      type="date"
                      id="date"
                      validation-container-class="col-lg-2"
                      name="expire_at"
                      label="تاریخ"
                      inputClass="form-control"
                      v-model="filter.date"
                    />
                    <bita-select
                      name="state"
                      label="استان مبدا"
                      ref="originStateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.origin_province_id"
                      @change="(e) => this.getCityOrgin(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesOrgin"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesOrgin === false"
                      name="citiesOrgin"
                      label="شهر مبدا"
                      ref="citiesOrginDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesOrgin"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.origin_city_id"
                    />
                    <bita-select
                      name="state"
                      label="استان مقصد"
                      ref="destinationstateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.destination_province_id"
                      @change="(e) => this.getCityDestination(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesDestination"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesDestination === false"
                      name="citiesDestination"
                      label="شهر مقصد"
                      ref="citiesDestinationDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesDestination"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.destination_city_id"
                    />
                  </div>
                </div>
              </bita-form>
            </div>
          </transition> -->
<exportexcel-form
  id="exportexcel-form"
  @on-submit="downloadExcel"
/>


          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize || 30"
            :current-page="currentPage"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import DateFilter from "./../../components/DateFilter";
import StateFilter from "./../../components/StateFilter";
import Tools from "../../components/Tools.vue";
import ExportExcelForm from "./ExportExcelForm.vue";


export default {
  components: { DateFilter, StateFilter, Tools,"exportexcel-form":ExportExcelForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "کیف پول", link: "/reports/wr1" },
        { title: "گزارش مالی", link: "/reports/wr1", active: true },
      ],
      isLoadingModal: false,
      isLoadingGrid: false,
      showFilters: false,
      // isLoadingCitiesOrgin: false,
      // isLoadingCitiesDestination: false,
      // updateForm: {
      //   driver_id: 0,
      // },
      pageSize: 0,
      currentPage: 0,
      filter: {
        state_id: 28,
      },
      // requests: {},
      // drivers: [],
      // customers: [],
      // states: [],
      // state: [],
      // citiesOrgin: [],
      // citiesDestination: [],
      total_amount: "",
      total_balance: "",
      gridColumns: [
        { title: "#", template: this.getTemplateID, width: "40px" },
        {
          field: "tracking_code",
          title: "کد‌پیگیری کیف پول",
          template: (e) => (e.tracking_code ? e.tracking_code : " - "),
          width: 150,
        },
        // {
        //   field: "request_detail_tracking_code",
        //   title: "کد‌پیگیری بار",
        //   template: (e) => (e.request_detail_tracking_code ? e.request_detail_tracking_code : " - "),
        // },
        {
          field: "amount",
          title: this.$currencyLabel("مبلغ"),
          footerTemplate: (e) =>
            e ? ` جمع کل  ${this.$thousandSeprator(this.total_amount)}` : "",
          template: (e) => {
            if (e.payment_state)
              return e.amount
                ? `<i class="fas fa-sort-up"></i> ${this.$thousandSeprator(
                    e.amount
                  )}`
                : " - ";
            return e.amount
              ? `<i class="fas fa-sort-down"></i> ${this.$thousandSeprator(
                  e.amount
                )}`
              : " 0 ";
          },
          width: 150,
        },
        {
          field: "user_name",
          title: "پرداخت کننده",
          footerTemplate: (e) =>
            ` موجودی کیف پول  ${this.$thousandSeprator(this.total_balance)}`,
          template: (e) =>
            e.user_name && e.user_family
              ? `${e.user_name} ${e.user_family}`
              : " - ",
          width: 150,
        },
        {
          field: "type_name",
          title: "نوع",
          width: 110,
        },
        {
          filed: "description",
          title: "توضیحات",
          template: (e) => (e.description ? e.description : "-"),
          width: 160,
        },
        {
          filed: "created_at",
          title: "تاریخ",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: 110,
        },
      ],
    };
  },
  computed: {
    filterTitle() {
      return this.showFilters ? "حذف فیلتر" : "فیلتر بیشتر";
    },
    urlExcel() {
      return `reports/export-excel-wr1?state_id=${this.filter.state_id ||
        ""}&from=${this.filter.from || ""}
        &to=${this.filter.to || ""}&user_id=${this.filter.user_id ||
        ""}&search=${this.filter.search || ""}`;
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  // mounted() {
  //   this.isLoadingGrid = true;
  //   Promise.all([
  //     this.getDrivers(),
  //     this.getStates(),
  //     this.getState(),
  //     this.getTotalBalance(),
  //   ]).then((res) => {
  //     this.drivers = res[0].data;
  //     this.states = res[1].data;
  //     this.state = res[2].data;
  //     this.total_balance = res[3].data.data;
  //     this.isLoadingGrid = false;
  //   });
  //   // this.getDrivers();
  //   // this.getRequests();
  //   this.loadData();
  //   this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  // },
  methods: {
    print() {
      this.$print("reports/export-wr1", this.filter);
    },
    // getState() {
    //   return this.$persistClient("get", "cities?filter[province]=0");
    // },
    // getCityOrgin(stateId) {
    //   this.isLoadingCitiesOrgin = true;
    //   this.$persistClient("get", `cities?filter[province]=${stateId}`)
    //     .then((res) => {
    //       this.citiesOrgin = res.data;
    //     })
    //     .finally(() => {
    //       this.isLoadingCitiesOrgin = false;
    //     });
    // },
    // getCityDestination(stateId) {
    //   this.isLoadingCitiesDestination = true;
    //   this.$persistClient("get", `cities?filter[province]=${stateId}`)
    //     .then((res) => {
    //       this.citiesDestination = res.data;
    //     })
    //     .finally(() => {
    //       this.isLoadingCitiesDestination = false;
    //     });
    // },
    // getStates() {
    //   return this.$persistClient("get", "states?filter[type]=requestdetail");
    // },
    // resetFilters() {
    //   let dropDowns = [
    //     "statesDropDown",
    //     "carrierDropDown",
    //     "originStateDropDown",
    //     "citiesOrginDropDown",
    //     "destinationstateDropDown",
    //     "citiesDestination",
    //   ];
    //   for (let ref of dropDowns) {
    //     if (this.$refs[ref]) this.$refs[ref].emptyKendo();
    //   }
    //   this.$refs.form.reset();
    // },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filter = {};
        // this.resetFilters();
        this.loadData();
      }
    },

    // onDataBinding: function(ev) {
    //   var vm = this;
    //   setTimeout(() => {
    //     var grid = $("#grid").data("kendoGrid");
    //     var items = ev.items;
    //     items.forEach(function(item) {
    //       var dataItem = item;
    //       var selector = $(`.k-master-row[data-uid=${item.uid}]`);
    //       if (!dataItem.payment_state && !vm.filter.state_id) {
    //         selector.css("color", `#c0392b`);
    //       }
    //       if (dataItem.payment_state && !vm.filter.state_id) {
    //         selector.css("color", `#1d8348`);
    //       }
    //     });
    //   }, 1000);
    //   this.record =
    //     (this.gpage - 1) * this.$refs.grid.$refs.datasource.pageSize;
    //   var grid = this.$refs.grid.$refs.grid.kendoWidget();
    //   // this.report.review == 2 ? grid.hideColumn(10) : "";
    // },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `reports/wr1?page=${this.currentPage}&page_size=${
        this.pageSize
      }&state_id=${this.filter.state_id || ""}&from=${this.filter.from ||
        ""}&to=${this.filter.to || ""}&user_id=${this.filter.user_id ||
        ""}&search=${this.filter.search || ""}`;
      this.$persistClient("get", baseUrl)
        .then((res) => {
          this.total_amount = res.data.data.total_amount;
          e.success(res.data.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });

      // this.$resetGrid();
      // this.isLoadingGrid = true;
      // let url = this.$makeQueryString(`reports/wr1`, this.filter);
      // this.$persistClient("get", url)
      //   .then((res) => {
      //     this.total_amount = res.data.data.total_amount;
      //     e.success(res.data.data.data);
      //   })
      //   .catch(() => {
      //     e.success([]);
      //   })
      //   .finally(() => {
      //     this.isLoadingGrid = false;
      //   });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
      toggleExportForm() {
      this.$toggleModal("#exportexcel-form");
    },
    // statusChangeModalEdit() {
    //   this.$toggleModal("#edit-modal");
    // },
    // gridCommands() {
    //   let commands = [];
    //   if (this.$acl.can("update", "requestsmanagements"))
    //     commands.push({
    //       text: "assign",
    //       click: this.edit,
    //       template: this.gridButtons.assignUser,
    //     });
    //   // commands.push({
    //   //   text: "delete",
    //   //   click: this.delete,
    //   //   template: this.gridButtons.delete,
    //   // });
    //   return commands;
    // },
    // edit(e) {
    //   let requestDetail = this.$refs.grid.getSelectedGridRow(e);

    //   this.updateForm = {
    //     id: requestDetail.id,
    //     driver_id: requestDetail.driver_id,
    //     amount_payable: requestDetail.amount_payable,
    //     driver_name:
    //       requestDetail.driver && requestDetail.driver.user
    //         ? `${requestDetail.driver.user.name} ${requestDetail.driver.user.family}`
    //         : "",
    //     driver_national_code:
    //       requestDetail.driver && requestDetail.driver.user
    //         ? requestDetail.driver.user.national_code
    //         : "",
    //     // customer_id: requestDetail.customer_id,
    //     // price: requestDetail.price ? requestDetail.price : '',
    //     // net_price: requestDetail.net_price ? requestDetail.net_price : '',
    //   };

    //   this.statusChangeModalEdit();
    // },
    // delete(e) {
    //   let requestDetail = this.$refs.grid.getSelectedGridRow(e);
    //   this.$alert(
    //     "question",
    //     `آیا از حذف ${requestDetail.name} اطمینان دارید؟`,
    //     "",
    //     {
    //       confirmButtonText: "بله",
    //     }
    //   ).then((result) => {
    //     if (result.value) {
    //       this.isLoadingGrid = true;
    //       this.$persistClient("delete", `request-details/${requestDetail.id}`)
    //         .then((res) => {
    //           this.$izitoast("success", "با موفقیت حذف شد", "موفق");
    //           this.loadData();
    //         })
    //         .finally(() => {
    //           this.isLoadingGrid = false;
    //         });
    //     }
    //   });
    // },
    // getRequests() {
    //   return this.$persistClient("get", `requests/${this.$route.params.id}`);
    // },
    // getDrivers() {
    //   return this.$persistClient("get", `drivers?include=user`);
    // },
    // getTotalBalance() {
    //   return this.$persistClient("get", "users/current/balance");
    // },
    // getCustomers() {
    //   return this.$persistClient("get", "customers");
    // },
    // handleEdit(data) {
    //   if (data.purchase_with == 2) {
    //     this.$alert(
    //       "question",
    //       `در صورت تایید مبلغ ${this.$thousandSeprator(data.amount_payable)} ${
    //         this.$cashUnit
    //       } از حساب شما کسر خواهد شد.`,
    //       "",
    //       {
    //         confirmButtonText: "بله",
    //       }
    //     ).then((result) => {
    //       if (result.value) this.approveRequestDetail(data);
    //     });
    //   } else {
    //     this.approveRequestDetail(data);
    //   }
    // },
    // approveRequestDetail(data) {
    //   this.isLoadingModal = true;

    //   this.$persistClient("patch", `request-details/${data.id}/assign`, data)
    //     .then((res) => {
    //       this.$izitoast("success", "عملیات موفق", res.data.message);

    //       this.updateForm = {
    //         driver_id: 0,
    //       };

    //       this.loadData();
    //       this.$refs.editModal.reset();

    //       this.statusChangeModalEdit();
    //     })
    //     .finally(() => {
    //       this.isLoadingModal = false;
    //     });
    // },
//  downloadExcel(formData) {
//     const excelPath = `reports/export-excel-wr1?state_id=${this.filter.state_id || ""}&from=${formData.from || ""}&to=${formData.to || ""}&user_id=${this.filter.user_id || ""}&search=${this.filter.search || ""}`;

//     const url = `${this.$apiURL}/${excelPath}`;

//     console.log(url)
//     window.open(url, "_blank");
//   }
downloadExcel(formData) {
  const params = new URLSearchParams({
    state_id: formData.state_id || "",
    from: formData.from || "",
    to: formData.to || "",
    user_id: this.filter.user_id || "",
    search: this.filter.search || "",
  });

  const url = `${this.$apiURL}/reports/export-excel-wr1?${params.toString()}`;
  window.open(url, "_blank");
}



  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
<style>
.status-paymentwaiting {
  background-color: #d7d005 !important;
}
.status-reserved {
  background-color: #000087 !important;
}
</style>
